import { handleRawData } from './utils'
import type createAllStore from 'src/store'
import type { GlobalStateType } from 'src/store/types'
import type { ModifyNameType, NodeValidateType } from 'src/types'

type DataType = Pick<
  GlobalStateType,
  'rawData' | 'saveStatus' | 'modifyName' | 'nodeValidates' | 'isLock'
>

function useUpdateData(store: ReturnType<typeof createAllStore>) {
  return [
    (props: Record<string, any> | Record<string, any>[]) => {
      if (!props)
        return
      console.log('useUpdateData ===>', props)
      const {
        setData,
        setIsLock,
        setRawData,
        setModifyName,
        setNodeValidates,
        setSaveStatus,
      } = store.getState()
      if (Array.isArray(props)) {
        const data: DataType = {} as DataType
        let hasSaveFlow = false
        props.forEach((n) => {
          switch (n.key) {
            case 'init': {
              if (n.value) {
                const rawData = handleRawData(JSON.parse(n.value as string))
                data.rawData = rawData
              }
              break
            }
            case 'saveFlow':
              hasSaveFlow = true
              data.saveStatus = true
              break
            case 'modifyName':
              data.modifyName = n.value as ModifyNameType
              break
            case 'nodeValidate':
              if (data.nodeValidates) {
                data.nodeValidates.push(n.value as NodeValidateType)
              }
              else {
                data.nodeValidates = [n.value as NodeValidateType]
              }
              break
            case 'lockFlow':
              data.isLock = n.value as boolean
              break
            default:
          }
        })
        // console.log('setData ===>', data);
        if (hasSaveFlow) {
          // NOTE: 后端会同时有 saveFlow 和 nodeValidate，当触发 saveFlow，需要忽略后端提供的 nodeValidate，因为当保存时，前端会重置 error，然后再check所有节点和条件
          data.nodeValidates = undefined
        }
        console.log(data)
        setData(data)
      }
      else {
        // console.log(props.key, props.value);
        switch (props.key) {
          case 'init':
            return setRawData(handleRawData(JSON.parse(props.value as string)))
          case 'saveFlow':
            return setSaveStatus(true)
          case 'modifyName':
            console.log(props.value)
            return setModifyName(props.value as ModifyNameType)
          case 'nodeValidates':
            return setNodeValidates([props.value as NodeValidateType])
          case 'lockFlow':
            console.log('lockFlow ===>', props.value)
            return setIsLock(props.value)
          default:
        }
      }
    },
  ]
}

export default useUpdateData
